module.exports = __webpack_public_path__ + "img/Pop-Quiz-Icon.1d4ca43e.svg";